import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import store from './redux/store'
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import i18n from './i18n/i18n';
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
<I18nextProvider i18n={i18next}>
    <Provider store={store}>
        <Suspense fallback={()=><>loading...</>}>
            <App />           
        </Suspense>
    </Provider>
</I18nextProvider>

)
